// src/main.jsx
import ReactDOM from 'react-dom/client';
import { BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import { UserProvider } from './contexts/UserContext';
import { OrderProvider } from './contexts/OrderContext';
import { AppointmentProvider } from './contexts/AppointmentContext';
import { registerServiceWorker } from './registerServiceWorker';

registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>  
      <UserProvider>
        <OrderProvider>
          <AppointmentProvider>
            <App />
          </AppointmentProvider>
        </OrderProvider>
      </UserProvider>
    </BrowserRouter>
  // </React.StrictMode>
);
